import { collection, doc, getDoc, getDocs, limit, orderBy, query, where } from 'firebase/firestore'
import store from './store'
import { firebaseDb } from '@web/firebase.js'

const actions = {
  async initiateGetPosts({ commit, state }) {
    commit('SET_LOADING_STATE', true)
    let now = Date.now()

    const q = query(
      collection(firebaseDb, 'links'),
      where('published', '==', true),
      where('publishedTimestamp', '<=', now),
      orderBy('publishedTimestamp', 'desc'),
      limit(state.pageLength),
    )

    const posts = []
    const snapshots = await getDocs(q)
    snapshots.forEach(doc => {
      posts.push({ ...doc.data(), id: doc.id })
      commit('SET_AFTER_TIMESTAMP', doc.data().publishedTimestamp)
    })

    let mappedPosts = posts.map(function (e) {
      return {
        id: e.id,
        image: e.images ? e.images[0] : 'not found',
        title: e.title,
        link: e.url,
        icon: e.favicons ? e.favicons[0] : '',
        siteName: e.siteName,
        timestamp: e.publishedTimestamp,
        timesClicked: e.timesClicked,
      }
    })

    commit('SET_POSTS', mappedPosts)
    commit('SET_LOADING_STATE', false)

    if (snapshots.size !== state.pageLength) {
      commit('SET_END')
    }
  },
  async getMorePosts({ commit, state }) {
    commit('SET_LOADING_STATE', true)

    const q = query(
      collection(firebaseDb, 'links'),
      where('published', '==', true),
      where('publishedTimestamp', '<=', state.startAfterTimestamp),
      orderBy('publishedTimestamp', 'desc'),
      limit(state.pageLength),
    )

    const posts = []
    const snapshots = await getDocs(q)
    snapshots.forEach(doc => {
      posts.push({ ...doc.data(), id: doc.id })
      commit('SET_AFTER_TIMESTAMP', doc.data().publishedTimestamp)
    })

    let mappedPosts = posts.map(function (e) {
      return {
        id: e.id,
        image: e.images ? e.images[0] : 'not found',
        title: e.title,
        link: e.url,
        icon: e.favicons ? e.favicons[0] : '',
        siteName: e.siteName,
        timestamp: e.publishedTimestamp,
        timesClicked: e.timesClicked,
      }
    })

    commit('APPEND_POSTS', mappedPosts)
    commit('SET_LOADING_STATE', false)

    if (snapshots.size !== state.pageLength) {
      commit('SET_END')
    }
  },
  async postClicked(ctx, postID) {
    const docRef = doc(firebaseDb, 'links', postID)
    const snapshot = await getDoc(docRef)

    if (!snapshot.exists) {
      return
    }

    let post = snapshot.data()
    let updatePostCall = doc(firebaseDb, 'links', postID)
    let updatedTimesClicked = post.timesClicked ? post.timesClicked + 1 : 1

    updatePostCall.update({
      timesClicked: updatedTimesClicked,
    })
  },
}
const state = {
  posts: [],

  pagesLoaded: 0,
  pageLength: 10,
  atEnd: false,
  startAfterTimestamp: null,

  loading: false,
}
const getters = {}
const mutations = {
  SET_LOADING_STATE(state, newLoadingState) {
    state.loading = newLoadingState
  },
  SET_AFTER_TIMESTAMP(state, newAfterTimestamp) {
    state.startAfterTimestamp = newAfterTimestamp
  },
  SET_POSTS(state, posts) {
    state.posts = posts
    state.pagesLoaded = 1
  },
  APPEND_POSTS(state, newPosts) {
    let posts = state.posts
    newPosts.forEach(e => posts.push(e))

    state.posts = posts
    state.pagesLoaded = state.pagesLoaded + 1
  },
  SET_END(state) {
    state.atEnd = true
  },
}

store.registerModule('POSTS', {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
})
